import angular from 'angular';
import nodeJvmStatsTable from './node-jvm-stats-table.component';

export default angular.module('eshq.nodeJvmStatsTable', [])
  .component('eshqNodeJvmStatsTable', nodeJvmStatsTable)
  .name;



// WEBPACK FOOTER //
// ./ui/src/components/node-jvm-stats-table/node-jvm-stats-table.js